import { SelectedItemsPanel } from 'pages/custom_tests_v1/components/assign_wizard/components/selected_items_panel/SelectedItemsPanel';
import type { AssignableItem } from 'pages/custom_tests_v1/components/assign_wizard/AssignWizard';
import type { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixTable } from 'components';
import { Button } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { formatDay } from 'utils';

type AccessCodePickerViewProps = {
    accessCodes: AssignableItem[];
    assignedIds?: number[];
    onChange: (selected: AssignableItem[]) => void;
    selected: AssignableItem[];
};

export const AccessCodePickerView = (props: AccessCodePickerViewProps) => {

    const { accessCodes, assignedIds = [], onChange, selected } = props;

    const intl = useIntl();
    const { formatMessage } = intl;

    const [state, setState] = useSuperState({
        searchTerm: ''
    });

    const setSearchTerm = (searchTerm: string) => setState({ searchTerm });

    const handleSelect = (accessCode: AssignableItem) => {

        if (selected.some(({ Id }) => Id === accessCode.Id)) return;

        onChange([...selected, accessCode]);

    };

    const handleRemove = (accessCode: AssignableItem) => onChange(selected.filter(({ Id }) => Id !== accessCode.Id));

    const displayList = (state.searchTerm
        ? accessCodes.filter(({ Identifier }) => Identifier.toLowerCase().includes(state.searchTerm.toLowerCase()))
        : accessCodes
    ).map(item => ({
        ...item,
        isSelected: selected.some(({ Id }) => Id === item.Id)
    }));

    const columns: GMetrixTableColumnProps<AssignableItem & { isSelected: boolean }>[] = [
        {
            field: 'Identifier',
            title: formatMessage({ id: 'identifier.45eac7f9', defaultMessage: 'Identifier' })
        },
        {
            field: 'UsesRemaining',
            title: formatMessage({ id: 'uses_remaining.d26b9e27', defaultMessage: 'Uses Remaining' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {formatDay(dataItem.CreatedDate, intl)}
                </td>
            ),
            field: 'CreatedDate',
            title: formatMessage({ id: 'created.8d9f8791', defaultMessage: 'Created' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {dataItem.isSelected ?
                        (
                            <Button disabled size={'sm'} variant={'outline-success'}>
                                <i className="fa-solid fa-check" />
                            </Button>
                        )
                        :
                        (
                            <Button
                                disabled={dataItem.isSelected}
                                onClick={() => handleSelect(dataItem)}
                                size={'sm'}
                            >
                                <i className="fa-solid fa-plus" />
                            </Button>
                        )
                    }

                </td>
            ),
            title: '',
            width: '1%'
        }
    ];

    return (
        <div className={'d-flex flex-column gap-3'}>

            <GMetrixTable
                columnData={columns}
                defaultItemsPerPage={10}
                noDataMessage={formatMessage({ id: 'no_access_codes_found.2ac9ae6b', defaultMessage: 'No access codes found.' })}
                rowData={displayList}
                searchTerm={state.searchTerm}
                setSearchTerm={setSearchTerm}
            />

            <SelectedItemsPanel assignedIds={assignedIds} items={selected} onRemove={handleRemove} />

        </div>
    );

};

AccessCodePickerView.displayName = 'AccessCodePickerView';